import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState, type ReactNode } from 'react'
import { Toaster } from 'sonner'

import { TooltipProvider } from '@/components/ui/menu'
import { ApiError } from '@/lib/api'

function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: true,
        // Client errors (4xx) won't fix themselves; only retry network/server failures.
        retry: (count, error) =>
          !(error instanceof ApiError && error.status >= 400 && error.status < 500) && count < 2,
      },
      mutations: { retry: false },
    },
  })
}

export function Providers({ children }: { children: ReactNode }) {
  const [client] = useState(createQueryClient)
  return (
    <QueryClientProvider client={client}>
      <TooltipProvider delayDuration={300}>
        {children}
        <Toaster
          position="bottom-right"
          gap={8}
          toastOptions={{
            classNames: {
              toast:
                '!rounded-[10px] !border !border-line !bg-surface !text-ink !shadow-pop !font-sans !text-[0.8125rem]',
              description: '!text-ink-3',
              success: '[&_[data-icon]]:!text-accent',
              error: '[&_[data-icon]]:!text-danger',
            },
          }}
        />
      </TooltipProvider>
    </QueryClientProvider>
  )
}
